import { rest } from 'app/rest'
import { Inference } from 'type/Inference'
import { Product } from 'type/Product'

class ApiController {
  async getInference(inference_id: string): Promise<Inference> {
    const request = { inference_id }
    return await rest.get('/api/inference', request)
  }

  async getProduct(product_id: string): Promise<Product | undefined> {
    try {
      const request = { product_id }
      return await rest.get('/api/product', request)
    } catch (e) {
      return undefined
    }
  }
}

export const api = new ApiController()
